import React, { useState } from 'react'
import {
  setTogglerImages,
  setTogglerVideos,
  setTogglerTours,
  setTogglerBlueprints,
  setCurrentlyBlueprint,
  setCurrentlyImage,
} from '@slices/galerySlice'
import { getTour, getBluePrints, getVideo } from '@helpers/helper.properties'
import SocialModal from '@components/socialModal/1'
import { addFavorites, checkFavorite, getfavorites } from '@helpers/helper.favorites'
import toast from 'react-hot-toast'
import { useLocation } from '@reach/router'
import {
  Development,
  MultiActionBar,
  MultiActionBar as MultiActionBarType,
  Property,
  RealEstateDataPageComponentData,
} from 'types'
import { useDispatch } from 'react-redux'
import { updateFavorites } from '@slices/propertiesSlice'

interface Props {
  data: Development | Property
  skeleton: boolean
  active?: string
  float?: boolean
  developmentID?: string
  propertyID?: string
  vertical?: boolean
  itemsBar?: MultiActionBarType | MultiActionBar
  thick?: boolean
}

const MultiActionBarComponent = ({
  data,
  itemsBar,
  vertical,
  skeleton,
  active = '',
  float = false,
  developmentID,
  propertyID,
  thick,
  global_data,
}: Props & RealEstateDataPageComponentData) => {
  const mediaBar = true

  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''
  const [listFavorites, setListFavorites] = useState(getfavorites('prop', 'template-site'))
  const location = useLocation()

  const dispatch = useDispatch()

  //   useEffect(() => {
  //     setListFavorites(getfavorites('prop', 'template'))
  //   }, [updaterFavorites])

  const toggleGallery = () => {
    if (active === '') {
      return
    }
    switch (active) {
      case 'video':
        return dispatch(setTogglerVideos())
      case 'image':
        return dispatch(setTogglerImages())
      case 'tour':
        return dispatch(setTogglerTours())
      case 'blueprint':
        return dispatch(setTogglerBlueprints())
    }
  }

  const toastCheck = (id: string, fake_address: string) => {
    if (!checkFavorite(id, 'prop', 'template-site'))
      return toast.success(fake_address + ' agregada a tus favoritos')
    else return toast.error(fake_address + ' eliminada de tus favoritos')
  }

  const functionGalleryFotos = () => {
    dispatch(setCurrentlyImage(1))
    dispatch(setTogglerImages())
    toggleGallery()
  }

  const functionGalleryVideos = () => {
    dispatch(setTogglerVideos())
    toggleGallery()
  }
  const functionGalleryTours = () => {
    dispatch(setTogglerTours())
    toggleGallery()
  }
  const functionGalleryBlueprints = () => {
    dispatch(setCurrentlyBlueprint(1))
    dispatch(setTogglerBlueprints())
    toggleGallery()
  }

  return (
    mediaBar && (
      <>
        <SocialModal
          global_data={global_data}
          property={propertyID ? data : null}
          development={developmentID ? data : null}
        />
        <div
          className={
            'multimediaDiv a ' +
            (vertical ? ' vertical ' : '') +
            (skeleton ? ' skeleton ' : '') +
            (thick ? ' is_thick ' : '') +
            (float && ' float-gallery') +
            (location?.href?.includes('emprendimiento') ? ' emprendimiento ' : '')
          }
        >
          <div className="multimediaRow d-flex">
            {itemsBar?.photos && (
              <div
                onClick={() => functionGalleryFotos()}
                className={'multimediaBar d-flex ' + (active === 'image' && 'active')}
              >
                <i className={`icon-gallery${iconsStyle} `}></i>
                <p className="d-none d-xxl-block">Fotos</p>
              </div>
            )}
            {itemsBar?.youtube && (
              <div
                onClick={() => functionGalleryVideos()}
                className={
                  'multimediaBar ' +
                  (active === 'video' && 'active') +
                  (getVideo(data).length === 0 ? ' d-none ' : ' d-flex ')
                }
              >
                <i className={`icon-youtube${iconsStyle} `}></i>
                <p className="d-none d-xxl-block">Video</p>
              </div>
            )}
            {itemsBar?.tours && (
              <div
                onClick={() => functionGalleryTours()}
                className={
                  'multimediaBar ' +
                  (active === 'tour' && 'active') +
                  (getTour(data)?.length === 0 ? ' d-none ' : ' d-flex ')
                }
              >
                <i className={`icon-tour${iconsStyle} `}></i>
                <p className="d-none d-xxl-block">Tour</p>
              </div>
            )}
            {itemsBar?.blueprints && (
              <div
                onClick={() => functionGalleryBlueprints()}
                className={
                  'multimediaBar ' +
                  (active === 'blueprint' && 'active') +
                  (getBluePrints(data).length === 0 ? ' d-none ' : ' d-flex ')
                }
              >
                <i className={`icon-unit${iconsStyle} `}></i>
                <p className="d-none d-xxl-block">Planos</p>
              </div>
            )}
            {itemsBar?.share && (
              <div className="multimediaBar d-flex">
                <div className="links-wrapper">
                  <button
                    data-bs-toggle="modal"
                    data-bs-target={'#modal-social-' + data?.id}
                    className="button-shared px-0 d-flex align-items-center"
                    type="button"
                  >
                    <span className="align-items-center d-flex">
                      <i className={`icon-share${iconsStyle} small-icon`}></i>
                    </span>
                    <p className="d-none d-xxl-block">Compartir</p>
                  </button>
                </div>
              </div>
            )}
            {itemsBar?.favorites && (
              <div
                onClick={() => {
                  dispatch(updateFavorites())
                  toastCheck(data?.id.toString(), data?.fake_address)
                  addFavorites(data?.id.toString(), 'prop', 'template-site')
                  setListFavorites(getfavorites('prop', 'template-site'))
                }}
                className={
                  'multimediaBar d-flex ' +
                  (location?.href?.includes('emprendimiento') ? ' d-none ' : '')
                }
              >
                <i
                  style={{ zIndex: '9' }}
                  className={
                    `icon-favoritos-heart${
                      listFavorites.find(
                        (element: any) => element?.toString() === data?.id?.toString(),
                      )
                        ? '-solid'
                        : iconsStyle
                    } fav ` +
                    (listFavorites?.find(
                      (element: any) => element?.toString() === data?.id?.toString(),
                    )
                      ? ' active ss animate__animated animate__heartBeat '
                      : '')
                  }
                ></i>
                <p className="d-none d-xxl-block">Favoritos</p>
              </div>
            )}
          </div>
        </div>
      </>
    )
  )
}

export default MultiActionBarComponent
// connect(state => ({
//     settings:state.settings,
//     currentlyImage:state.properties.currentlyImage,
//     updaterFavorites:state.properties.updaterFavorites,
//     currentlyBluePrint:state.properties.currentlyBluePrint,
//     togglerImages: state.properties.togglerImages,
//     togglerVideos: state.properties.togglerVideos,
//     togglerTours: state.properties.togglerTours,
//     togglerBlueprints: state.properties.togglerBlueprints,
// }),null)(MultiActionBar);
